<div
  fxLayout="column"
  fxLayoutGap="10px"
  class="dashboard-category-list-dialog"
  [ngClass]="
    selectedStudy
      ? selectedStudy?.type === StudyType.TIIM
        ? 'tiim-material-theme'
        : 'cc-material-theme'
      : 'dashboard-material-theme'
  "
>
  <dashboard-dialog-title
    [title]="selectedModule?.translations | dashboardTranslate: 'title':selectedLanguage?.code"
  ></dashboard-dialog-title>
  <div fxFill>
    <mat-form-field fxFlex="100">
      <input matInput [(ngModel)]="newLabel" placeholder="Category Label" />
    </mat-form-field>
    <button mat-button color="primary" type="button" (click)="addCategory()">
      {{ 'Add' | uppercase }}
    </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div>Category List: &nbsp;</div>
    <mat-chip-list aria-label="Category Labels">
      <mat-chip
        selected
        color="accent"
        [removable]="true"
        (removed)="removeCategory(category)"
        *ngFor="let category of categoryList"
      >
        {{ category?.label }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
